export default class ImageLoader {
  constructor($dst, options = {}) {
    this.$dst = $dst
    this.options = options

    this.$dst
      .on('drag dragstart dragend dragover dragenter dragleave drop', e => {
        e.preventDefault()
        e.stopPropagation()
      })
      .on('drop', this.handleDropFiles.bind(this))
  }

  handleDropFiles(e) {
    const { onDropFile } = this.options
    const droppedFiles = e.originalEvent.dataTransfer.files

    if (onDropFile) onDropFile()

    this.loadFile(droppedFiles)
  }

  loadFile(files) {
    const { onUpload, onUploading } = this.options

    if (onUploading) onUploading()

    for (const file in files) {
      if (file === 'length' || file === 'item') continue

      const formData = new FormData()
      formData.append('image', files[file])
      formData.append('type', this.options.type)
      formData.append('post_id', this.options.postId)

      $.ajax({
        url: `/admin/publication_attachment`,
        data: formData,
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        type: 'POST',
      }).done(function (res) {
        if (onUpload)
          onUpload({
            url: res.medium_url,
            identifier: res.identifier,
          })
      })
    }
  }

  removeFile(url) {
    const { onRemove } = this.options

    const formData = new FormData()
    formData.append('url', url)
    formData.append('type', this.options.type)
    formData.append('post_id', this.options.postId)

    $.ajax({
      url: `/admin/publication_attachment`,
      data: formData,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      type: 'DELETE',
    }).success(function (res) {
      if (onRemove) onRemove(res)
    })
  }
}
